import React, { useState, useEffect } from 'react';

const API = process.env.REACT_APP_API_URL || 'https://surabaya-api.onrender.com';
const PASSWORD = 'surabaya2026';

async function getToken() {
  const res = await fetch(`${API}/api/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ password: PASSWORD })
  });
  const data = await res.json();
  return data.token;
}

function badgeStatut(statut) {
  const map = {
    brouillon: { bg: '#3a3a4a', label: 'Brouillon' },
    valide:    { bg: '#2563eb', label: 'Validé' },
    envoye:    { bg: '#f59e0b', label: 'Envoyé' },
    recu:      { bg: '#16a34a', label: 'Reçu' },
    annule:    { bg: '#6b7280', label: 'Annulé' }
  };
  const c = map[statut] || { bg: '#333', label: statut };
  return <span style={{ background: c.bg, color:'#fff', padding:'4px 10px', borderRadius:'6px', fontSize:'12px', fontWeight:'bold' }}>{c.label}</span>;
}

// Une ligne sans composant_id ET sans fc_ingredient_id = ligne libre
function isLigneLibre(l) {
  return !l.composant_id && !l.fc_ingredient_id;
}

export default function BonsCommandePanel({ s }) {
  const [bcList, setBcList] = useState([]);
  const [bcLoading, setBcLoading] = useState(false);
  const [bcDetail, setBcDetail] = useState(null);
  const [bcFiltreStatut, setBcFiltreStatut] = useState('');
  const [bcEnvoiModal, setBcEnvoiModal] = useState(null);
  const [bcEnvoiEmail, setBcEnvoiEmail] = useState('');
  const [bcEnvoiMessage, setBcEnvoiMessage] = useState('');
  const [bcReceptionModal, setBcReceptionModal] = useState(null);
  const [bcReceptionLignes, setBcReceptionLignes] = useState({});
  const [bcGenerateLoading, setBcGenerateLoading] = useState(false);
  const [msg, setMsg] = useState('');

  // Modal ajout de ligne
  const [bcAjoutModal, setBcAjoutModal] = useState(null); // contient le bcDetail
  const [ajoutMode, setAjoutMode] = useState('composant'); // 'composant' | 'libre'
  const [ajoutSources, setAjoutSources] = useState({ composants: [], fc_ingredients: [] });
  const [ajoutSourceKey, setAjoutSourceKey] = useState(''); // ex: "comp:11" ou "fc:42"
  const [ajoutQte, setAjoutQte] = useState('');
  const [ajoutLibelle, setAjoutLibelle] = useState('');
  const [ajoutUnite, setAjoutUnite] = useState('u');
  const [ajoutPrix, setAjoutPrix] = useState('');
  const [ajoutLoading, setAjoutLoading] = useState(false);

  // Modal creation BC vide
  const [nouveauBcModal, setNouveauBcModal] = useState(false);
  const [nouveauBcFournisseur, setNouveauBcFournisseur] = useState('');
  const [nouveauBcNotes, setNouveauBcNotes] = useState('');
  const [nouveauBcLoading, setNouveauBcLoading] = useState(false);

  // Liste des fournisseurs deja vus (pour autocomplete)
  const fournisseursConnus = Array.from(new Set(bcList.map(b => b.fournisseur).filter(Boolean))).sort();

  async function loadBonsCommande() {
    setBcLoading(true);
    try {
      const token = await getToken();
      const url = `${API}/api/admin/bons-commande` + (bcFiltreStatut ? `?statut=${bcFiltreStatut}` : '');
      const res = await fetch(url, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.ok) setBcList(data.items);
    } catch (e) { console.error('Erreur load BC:', e); }
    finally { setBcLoading(false); }
  }

  async function loadBcDetail(id) {
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/bons-commande/${id}`, { headers: { Authorization: `Bearer ${token}` } });
      const data = await res.json();
      if (data.ok) setBcDetail({ bc: data.bc, lignes: data.lignes });
    } catch (e) { console.error('Erreur detail BC:', e); }
  }

  async function bcAction(id, action, body) {
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/bons-commande/${id}/${action}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: body ? JSON.stringify(body) : '{}'
      });
      const data = await res.json();
      if (data.ok) {
        setMsg('✅ ' + (data.message || 'OK'));
        loadBonsCommande();
        if (bcDetail && bcDetail.bc.id === id) loadBcDetail(id);
      } else { setMsg('❌ ' + (data.error || 'Erreur')); }
      setTimeout(() => setMsg(''), 3500);
      return data;
    } catch (e) { setMsg('❌ ' + e.message); }
  }

  async function bcGenerateNow() {
    setBcGenerateLoading(true);
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/bons-commande/generate-now`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.ok) {
        setMsg(data.count > 0 ? `✅ ${data.count} BC généré(s)` : 'ℹ️ Aucun composant en alerte');
        loadBonsCommande();
      } else setMsg('❌ ' + data.error);
      setTimeout(() => setMsg(''), 4000);
    } catch (e) { setMsg('❌ ' + e.message); }
    finally { setBcGenerateLoading(false); }
  }

  function ouvrirReceptionModal(bcDet) {
    const init = {};
    bcDet.lignes.forEach(l => { init[l.id] = l.quantite; });
    setBcReceptionLignes(init);
    setBcReceptionModal(bcDet);
  }

  async function envoyerReception() {
    if (!bcReceptionModal) return;
    const lignes_recues = Object.keys(bcReceptionLignes).map(lid => ({
      ligne_id: parseInt(lid, 10),
      quantite_recue: parseFloat(bcReceptionLignes[lid] || 0)
    }));
    const data = await bcAction(bcReceptionModal.bc.id, 'recevoir', { lignes_recues });
    if (data && data.ok) { setBcReceptionModal(null); setBcDetail(null); }
  }

  async function envoyerFournisseur() {
    if (!bcEnvoiModal || !bcEnvoiEmail) return;
    const data = await bcAction(bcEnvoiModal.id, 'envoyer', { destinataire: bcEnvoiEmail, message: bcEnvoiMessage || null });
    if (data && data.ok) { setBcEnvoiModal(null); setBcEnvoiEmail(''); setBcEnvoiMessage(''); }
  }

  // ---------- AJOUT / SUPPRESSION DE LIGNES ----------

  async function ouvrirAjoutModal(bcDet) {
    setBcAjoutModal(bcDet);
    setAjoutMode('composant');
    setAjoutSourceKey('');
    setAjoutQte('');
    setAjoutLibelle('');
    setAjoutUnite('u');
    setAjoutPrix('');
    // Charger les sources dispo pour ce fournisseur
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/bons-commande/${bcDet.bc.id}/sources-disponibles`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.ok) {
        setAjoutSources({ composants: data.composants || [], fc_ingredients: data.fc_ingredients || [] });
        // Si rien de dispo, bascule direct en mode libre
        if ((!data.composants || data.composants.length === 0) && (!data.fc_ingredients || data.fc_ingredients.length === 0)) {
          setAjoutMode('libre');
        }
      }
    } catch (e) { console.error('Erreur sources:', e); setAjoutMode('libre'); }
  }

  async function submitAjoutLigne() {
    if (!bcAjoutModal) return;
    setAjoutLoading(true);
    try {
      let body = {};
      if (ajoutMode === 'composant') {
        if (!ajoutSourceKey) { setMsg('❌ Sélectionne un produit'); setTimeout(() => setMsg(''), 2500); setAjoutLoading(false); return; }
        const [type, idStr] = ajoutSourceKey.split(':');
        const sid = parseInt(idStr, 10);
        if (type === 'comp') body = { source: 'composant', composant_id: sid, quantite: parseFloat(ajoutQte) || undefined };
        else body = { source: 'fc_ingredient', fc_ingredient_id: sid, quantite: parseFloat(ajoutQte) || undefined };
      } else {
        if (!ajoutLibelle.trim() || !ajoutQte) {
          setMsg('❌ Libellé et quantité requis'); setTimeout(() => setMsg(''), 2500); setAjoutLoading(false); return;
        }
        body = {
          source: 'libre',
          libelle: ajoutLibelle.trim(),
          quantite: parseFloat(ajoutQte),
          unite: ajoutUnite || 'u',
          prix_unitaire_ht: parseFloat(ajoutPrix) || 0
        };
      }
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/bons-commande/${bcAjoutModal.bc.id}/lignes`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify(body)
      });
      const data = await res.json();
      if (data.ok) {
        setMsg('✅ ' + data.message);
        setBcAjoutModal(null);
        loadBcDetail(bcAjoutModal.bc.id);
        loadBonsCommande();
      } else {
        setMsg('❌ ' + (data.error || 'Erreur'));
      }
      setTimeout(() => setMsg(''), 3500);
    } catch (e) { setMsg('❌ ' + e.message); setTimeout(() => setMsg(''), 3500); }
    finally { setAjoutLoading(false); }
  }

  async function submitNouveauBc() {
    if (!nouveauBcFournisseur.trim()) {
      setMsg('❌ Fournisseur requis');
      setTimeout(() => setMsg(''), 2500);
      return;
    }
    setNouveauBcLoading(true);
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/bons-commande`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          fournisseur: nouveauBcFournisseur.trim(),
          notes: nouveauBcNotes.trim() || null
        })
      });
      const data = await res.json();
      if (data.ok) {
        setMsg('✅ ' + data.message);
        setNouveauBcModal(false);
        setNouveauBcFournisseur('');
        setNouveauBcNotes('');
        await loadBonsCommande();
        // Ouvre directement le detail du BC cree pour ajouter des lignes
        loadBcDetail(data.bc.id);
      } else {
        setMsg('❌ ' + (data.error || 'Erreur'));
      }
      setTimeout(() => setMsg(''), 3500);
    } catch (e) { setMsg('❌ ' + e.message); setTimeout(() => setMsg(''), 3500); }
    finally { setNouveauBcLoading(false); }
  }

  async function supprimerLigne(bcId, ligneId) {
    if (!window.confirm('Supprimer cette ligne ?')) return;
    try {
      const token = await getToken();
      const res = await fetch(`${API}/api/admin/bons-commande/${bcId}/lignes/${ligneId}`, {
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.ok) {
        setMsg('✅ Ligne supprimée');
        loadBcDetail(bcId);
        loadBonsCommande();
      } else { setMsg('❌ ' + (data.error || 'Erreur')); }
      setTimeout(() => setMsg(''), 3000);
    } catch (e) { setMsg('❌ ' + e.message); setTimeout(() => setMsg(''), 3000); }
  }

  useEffect(() => { loadBonsCommande(); /* eslint-disable-next-line */ }, [bcFiltreStatut]);

  const isBrouillon = bcDetail && bcDetail.bc.statut === 'brouillon';

  return (
    <div>
      {msg && <div style={{ background:'#0f3460', color:'#fff', padding:'10px', borderRadius:'8px', marginBottom:'12px', textAlign:'center' }}>{msg}</div>}

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px', flexWrap:'wrap', gap:'10px' }}>
        <select value={bcFiltreStatut} onChange={e => setBcFiltreStatut(e.target.value)} style={{ padding:'8px 12px', borderRadius:'8px', background:'#0f3460', color:'#fff', border:'1px solid #333' }}>
          <option value="">Tous les statuts</option>
          <option value="brouillon">📝 Brouillon</option>
          <option value="valide">✓ Validé</option>
          <option value="envoye">📤 Envoyé</option>
          <option value="recu">✅ Reçu</option>
          <option value="annule">🚫 Annulé</option>
        </select>
        <div style={{ display:'flex', gap:'10px' }}>
          <button onClick={loadBonsCommande} style={{...s.btn, background:'#0f3460'}}>🔄 Rafraîchir</button>
          <button onClick={() => { setNouveauBcModal(true); setNouveauBcFournisseur(''); setNouveauBcNotes(''); }} style={{...s.btn, background:'#7c3aed'}}>➕ Nouveau BC</button>
          <button onClick={bcGenerateNow} disabled={bcGenerateLoading} style={s.btn}>
            {bcGenerateLoading ? '⏳ Génération...' : '⚡ Générer maintenant'}
          </button>
        </div>
      </div>

      {bcLoading && <div style={{ textAlign:'center', padding:'20px', color:'#aaa' }}>Chargement...</div>}

      {!bcLoading && bcList.length === 0 && (
        <div style={{ textAlign:'center', padding:'40px', color:'#aaa' }}>
          Aucun bon de commande. Le prochain cron tourne lundi/jeudi à 7h05.
        </div>
      )}

      {!bcLoading && bcList.length > 0 && (
        <table style={s.table}>
          <thead>
            <tr>
              <th style={s.th}>Numéro</th>
              <th style={s.th}>Date</th>
              <th style={s.th}>Fournisseur</th>
              <th style={s.th}>Lignes</th>
              <th style={s.th}>Total HT</th>
              <th style={s.th}>Statut</th>
              <th style={s.th}>Action</th>
            </tr>
          </thead>
          <tbody>
            {bcList.map(bc => (
              <tr key={bc.id}>
                <td style={s.td}><strong>{bc.numero}</strong></td>
                <td style={s.td}>{new Date(bc.date_creation).toLocaleDateString('fr-FR')}</td>
                <td style={s.td}>{bc.fournisseur}</td>
                <td style={s.td}>{bc.nb_lignes}</td>
                <td style={s.td}>{parseFloat(bc.total_ht).toFixed(2)} €</td>
                <td style={s.td}>{badgeStatut(bc.statut)}</td>
                <td style={s.td}>
                  <button onClick={() => loadBcDetail(bc.id)} style={{...s.btn, padding:'6px 12px', fontSize:'13px'}}>👁️ Voir</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {bcDetail && (
        <div style={s.modal}>
          <div style={{ ...s.modalBox, maxWidth:'750px' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
              <h3 style={{ color:'#e94560', margin:0 }}>📦 {bcDetail.bc.numero} — {bcDetail.bc.fournisseur}</h3>
              {badgeStatut(bcDetail.bc.statut)}
            </div>
            <div style={{ background:'#0f3460', padding:'12px', borderRadius:'8px', marginBottom:'16px', fontSize:'13px' }}>
              📅 Créé le {new Date(bcDetail.bc.date_creation).toLocaleDateString('fr-FR')}
              {bcDetail.bc.date_envoi && <> • 📤 Envoyé le {new Date(bcDetail.bc.date_envoi).toLocaleDateString('fr-FR')}</>}
              {bcDetail.bc.date_reception && <> • ✅ Reçu le {new Date(bcDetail.bc.date_reception).toLocaleDateString('fr-FR')}</>}
              {bcDetail.bc.email_envoye_a && <div style={{ marginTop:'4px' }}>📧 → {bcDetail.bc.email_envoye_a}</div>}
            </div>
            <table style={s.table}>
              <thead>
                <tr>
                  <th style={s.th}>Article</th>
                  <th style={s.th}>Qté commandée</th>
                  <th style={s.th}>Qté reçue</th>
                  <th style={s.th}>PU HT</th>
                  <th style={s.th}>Total</th>
                  {isBrouillon && <th style={s.th}></th>}
                </tr>
              </thead>
              <tbody>
                {bcDetail.lignes.map(l => (
                  <tr key={l.id}>
                    <td style={s.td}>
                      {l.composant_nom_snapshot}
                      {isLigneLibre(l) && (
                        <span title="Ligne ajoutée manuellement (hors stock)" style={{ marginLeft:'6px', background:'#7c3aed', color:'#fff', padding:'2px 6px', borderRadius:'4px', fontSize:'10px', fontWeight:'bold' }}>📝 MANUEL</span>
                      )}
                    </td>
                    <td style={s.td}>{l.quantite} {(l.unite_commande_snapshot || l.unite_snapshot || '')}</td>
                    <td style={s.td}>{l.quantite_recue !== null ? `${l.quantite_recue} ${(l.unite_commande_snapshot || l.unite_snapshot || '')}` : '—'}</td>
                    <td style={s.td}>{parseFloat(l.prix_unitaire_ht_snapshot).toFixed(2)} €</td>
                    <td style={s.td}>{parseFloat(l.total_ligne_ht || 0).toFixed(2)} €</td>
                    {isBrouillon && (
                      <td style={s.td}>
                        <button
                          title="Supprimer la ligne"
                          onClick={() => supprimerLigne(bcDetail.bc.id, l.id)}
                          style={{ background:'#7f1d1d', color:'#fff', border:'none', padding:'4px 8px', borderRadius:'6px', cursor:'pointer', fontSize:'13px' }}
                        >🗑️</button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>

            {isBrouillon && (
              <div style={{ marginTop:'10px' }}>
                <button
                  onClick={() => ouvrirAjoutModal(bcDetail)}
                  style={{ ...s.btn, background:'#0f3460', fontSize:'13px', padding:'8px 14px' }}
                >➕ Ajouter une ligne</button>
              </div>
            )}

            <div style={{ marginTop:'12px', textAlign:'right', fontWeight:'bold', color:'#e94560', fontSize:'16px' }}>
              Total : {parseFloat(bcDetail.bc.total_ht).toFixed(2)} € HT
            </div>
            {bcDetail.bc.notes && <div style={{ background:'#0f3460', padding:'10px', borderRadius:'6px', marginTop:'12px', fontSize:'12px', whiteSpace:'pre-wrap' }}>{bcDetail.bc.notes}</div>}
            <div style={{ display:'flex', gap:'10px', marginTop:'16px', flexWrap:'wrap' }}>
              {bcDetail.bc.statut === 'brouillon' && (
                <button style={s.btn} onClick={() => bcAction(bcDetail.bc.id, 'valider')}>✓ Valider</button>
              )}
              {(bcDetail.bc.statut === 'brouillon' || bcDetail.bc.statut === 'valide') && (
                <button style={{...s.btn, background:'#f59e0b'}} onClick={() => { setBcEnvoiModal(bcDetail.bc); setBcEnvoiEmail(''); setBcEnvoiMessage(''); }}>📤 Envoyer</button>
              )}
              {(bcDetail.bc.statut === 'envoye' || bcDetail.bc.statut === 'valide') && (
                <button style={{...s.btn, background:'#16a34a'}} onClick={() => ouvrirReceptionModal(bcDetail)}>✅ Recevoir</button>
              )}
              {bcDetail.bc.statut !== 'recu' && bcDetail.bc.statut !== 'annule' && (
                <button style={{...s.btn, background:'#6b7280'}} onClick={() => { if(window.confirm('Annuler ce BC ?')) bcAction(bcDetail.bc.id, 'annuler', { motif: 'Annulation manuelle' }); }}>🚫 Annuler</button>
              )}
              <button style={{...s.btn, background:'#333'}} onClick={() => setBcDetail(null)}>Fermer</button>
            </div>
          </div>
        </div>
      )}

      {bcEnvoiModal && (
        <div style={s.modal}>
          <div style={s.modalBox}>
            <h3 style={{ color:'#e94560', marginBottom:'16px' }}>📤 Envoyer {bcEnvoiModal.numero} à {bcEnvoiModal.fournisseur}</h3>
            <label style={s.label}>Email destinataire</label>
            <input style={s.input} type="email" value={bcEnvoiEmail} onChange={e => setBcEnvoiEmail(e.target.value)} placeholder="commercial@labrelok.fr" />
            <label style={s.label}>Message (optionnel)</label>
            <textarea style={{...s.input, minHeight:'80px', fontFamily:'inherit'}} value={bcEnvoiMessage} onChange={e => setBcEnvoiMessage(e.target.value)} placeholder="Bonjour, voici notre commande..." />
            <div style={{ background:'#0f3460', padding:'10px', borderRadius:'6px', marginTop:'10px', fontSize:'12px', color:'#aaa' }}>
              ℹ️ Une copie sera envoyée à commande@surabayacafe.fr
            </div>
            <div style={{ display:'flex', gap:'10px', marginTop:'16px' }}>
              <button style={s.btn} onClick={envoyerFournisseur} disabled={!bcEnvoiEmail}>📤 Envoyer</button>
              <button style={{...s.btn, background:'#333'}} onClick={() => setBcEnvoiModal(null)}>Annuler</button>
            </div>
          </div>
        </div>
      )}

      {bcReceptionModal && (
        <div style={s.modal}>
          <div style={{...s.modalBox, maxWidth:'600px'}}>
            <h3 style={{ color:'#e94560', marginBottom:'16px' }}>✅ Réceptionner {bcReceptionModal.bc.numero}</h3>
            <p style={{ fontSize:'13px', color:'#aaa', marginBottom:'16px' }}>
              Saisis la quantité réellement reçue pour chaque ligne. Si moins que commandé, un BC reliquat sera créé automatiquement.
            </p>
            {bcReceptionModal.lignes.map(l => (
              <div key={l.id} style={{ background:'#0f3460', padding:'12px', borderRadius:'8px', marginBottom:'10px' }}>
                <div style={{ marginBottom:'8px', fontWeight:'bold' }}>
                  {l.composant_nom_snapshot}
                  {isLigneLibre(l) && <span style={{ marginLeft:'6px', background:'#7c3aed', color:'#fff', padding:'2px 6px', borderRadius:'4px', fontSize:'10px' }}>📝 MANUEL</span>}
                </div>
                <div style={{ display:'flex', alignItems:'center', gap:'10px' }}>
                  <span style={{ fontSize:'13px', color:'#aaa' }}>Commandé : <strong style={{ color:'#fff' }}>{l.quantite} {(l.unite_commande_snapshot || l.unite_snapshot || '')}</strong></span>
                  <span style={{ fontSize:'13px', color:'#aaa' }}>Reçu :</span>
                  <input type="number" step="0.01" min="0" max={l.quantite}
                    style={{ ...s.input, width:'100px', margin:0, padding:'6px 10px' }}
                    value={bcReceptionLignes[l.id] || ''}
                    onChange={e => setBcReceptionLignes({...bcReceptionLignes, [l.id]: e.target.value})}
                  />
                  <span style={{ fontSize:'13px', color:'#aaa' }}>{(l.unite_commande_snapshot || l.unite_snapshot || '')}</span>
                </div>
              </div>
            ))}
            <div style={{ display:'flex', gap:'10px', marginTop:'16px' }}>
              <button style={{...s.btn, background:'#16a34a'}} onClick={envoyerReception}>✅ Confirmer réception</button>
              <button style={{...s.btn, background:'#333'}} onClick={() => setBcReceptionModal(null)}>Annuler</button>
            </div>
          </div>
        </div>
      )}

      {bcAjoutModal && (
        <div style={s.modal}>
          <div style={{...s.modalBox, maxWidth:'600px'}}>
            <h3 style={{ color:'#e94560', marginBottom:'16px' }}>➕ Ajouter une ligne sur {bcAjoutModal.bc.numero}</h3>

            <div style={{ display:'flex', gap:'8px', marginBottom:'16px' }}>
              <button
                onClick={() => setAjoutMode('composant')}
                style={{
                  ...s.btn,
                  flex: 1,
                  background: ajoutMode === 'composant' ? '#e94560' : '#333',
                  fontSize:'13px'
                }}
              >📦 Depuis la base ({(ajoutSources.composants.length + ajoutSources.fc_ingredients.length)})</button>
              <button
                onClick={() => setAjoutMode('libre')}
                style={{
                  ...s.btn,
                  flex: 1,
                  background: ajoutMode === 'libre' ? '#e94560' : '#333',
                  fontSize:'13px'
                }}
              >📝 Ligne libre</button>
            </div>

            {ajoutMode === 'composant' && (
              <>
                {(ajoutSources.composants.length + ajoutSources.fc_ingredients.length) === 0 ? (
                  <div style={{ background:'#0f3460', padding:'14px', borderRadius:'8px', fontSize:'13px', color:'#aaa', marginBottom:'12px' }}>
                    Aucun produit configuré pour <strong style={{ color:'#fff' }}>{bcAjoutModal.bc.fournisseur}</strong>. Bascule sur le mode "Ligne libre" ou configure d'abord un composant.
                  </div>
                ) : (
                  <>
                    <label style={s.label}>Produit</label>
                    <select
                      value={ajoutSourceKey}
                      onChange={e => setAjoutSourceKey(e.target.value)}
                      style={s.input}
                    >
                      <option value="">— Choisir un produit —</option>
                      {ajoutSources.composants.length > 0 && (
                        <optgroup label="📦 Stock semi-finis">
                          {ajoutSources.composants.map(c => (
                            <option key={'comp:' + c.id} value={'comp:' + c.id}>
                              {c.nom} — {parseFloat(c.prix_achat_ht || 0).toFixed(2)}€/{c.unite_commande || c.unite}
                            </option>
                          ))}
                        </optgroup>
                      )}
                      {ajoutSources.fc_ingredients.length > 0 && (
                        <optgroup label="🍳 Ingrédients cuisine">
                          {ajoutSources.fc_ingredients.map(f => (
                            <option key={'fc:' + f.id} value={'fc:' + f.id}>
                              {f.nom} — {parseFloat(f.prix_achat_ht || 0).toFixed(2)}€/{f.unite}
                            </option>
                          ))}
                        </optgroup>
                      )}
                    </select>

                    <label style={s.label}>Quantité (vide = qté par défaut du composant)</label>
                    <input
                      type="number" step="0.01" min="0"
                      style={s.input}
                      value={ajoutQte}
                      onChange={e => setAjoutQte(e.target.value)}
                      placeholder="Laisser vide pour utiliser la qté de réappro"
                    />
                  </>
                )}
              </>
            )}

            {ajoutMode === 'libre' && (
              <>
                <div style={{ background:'#0f3460', padding:'10px', borderRadius:'6px', fontSize:'12px', color:'#aaa', marginBottom:'12px' }}>
                  ℹ️ Les lignes libres ne sont pas liées au stock. Utile pour les achats ponctuels (matériel, dépannage, articles non configurés).
                </div>
                <label style={s.label}>Libellé</label>
                <input
                  style={s.input}
                  value={ajoutLibelle}
                  onChange={e => setAjoutLibelle(e.target.value)}
                  placeholder="ex: Rouleau papier alu pro"
                />
                <div style={{ display:'flex', gap:'10px' }}>
                  <div style={{ flex: 2 }}>
                    <label style={s.label}>Quantité</label>
                    <input
                      type="number" step="0.01" min="0"
                      style={s.input}
                      value={ajoutQte}
                      onChange={e => setAjoutQte(e.target.value)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={s.label}>Unité</label>
                    <input
                      style={s.input}
                      value={ajoutUnite}
                      onChange={e => setAjoutUnite(e.target.value)}
                      placeholder="u, kg, L..."
                    />
                  </div>
                  <div style={{ flex: 2 }}>
                    <label style={s.label}>PU HT (€)</label>
                    <input
                      type="number" step="0.01" min="0"
                      style={s.input}
                      value={ajoutPrix}
                      onChange={e => setAjoutPrix(e.target.value)}
                      placeholder="0.00"
                    />
                  </div>
                </div>
              </>
            )}

            <div style={{ display:'flex', gap:'10px', marginTop:'16px' }}>
              <button
                style={s.btn}
                onClick={submitAjoutLigne}
                disabled={ajoutLoading}
              >{ajoutLoading ? '⏳ Ajout...' : '➕ Ajouter'}</button>
              <button style={{...s.btn, background:'#333'}} onClick={() => setBcAjoutModal(null)}>Annuler</button>
            </div>
          </div>
        </div>
      )}
      {nouveauBcModal && (
        <div style={s.modal}>
          <div style={s.modalBox}>
            <h3 style={{ color:'#e94560', marginBottom:'16px' }}>➕ Nouveau bon de commande</h3>
            <p style={{ fontSize:'13px', color:'#aaa', marginBottom:'16px' }}>
              Crée un BC brouillon vide. Tu pourras y ajouter des lignes ensuite (depuis la base ou en saisie libre).
            </p>

            <label style={s.label}>Fournisseur</label>
            <input
              style={s.input}
              value={nouveauBcFournisseur}
              onChange={e => setNouveauBcFournisseur(e.target.value)}
              placeholder="ex: Boucherie Dupont"
              list="fournisseurs-connus"
              autoFocus
            />
            <datalist id="fournisseurs-connus">
              {fournisseursConnus.map(f => <option key={f} value={f} />)}
            </datalist>
            {fournisseursConnus.length > 0 && (
              <div style={{ fontSize:'11px', color:'#888', marginTop:'4px', marginBottom:'10px' }}>
                💡 Tape pour voir les fournisseurs déjà utilisés, ou saisis-en un nouveau.
              </div>
            )}

            <label style={s.label}>Notes (optionnel)</label>
            <textarea
              style={{...s.input, minHeight:'70px', fontFamily:'inherit'}}
              value={nouveauBcNotes}
              onChange={e => setNouveauBcNotes(e.target.value)}
              placeholder="ex: Catalogue présenté par M. Dupont le 7 mai"
            />

            <div style={{ display:'flex', gap:'10px', marginTop:'16px' }}>
              <button
                style={s.btn}
                onClick={submitNouveauBc}
                disabled={nouveauBcLoading || !nouveauBcFournisseur.trim()}
              >{nouveauBcLoading ? '⏳ Création...' : '➕ Créer le BC'}</button>
              <button style={{...s.btn, background:'#333'}} onClick={() => setNouveauBcModal(false)}>Annuler</button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}
